package meineglasfaser.frontend.www.components

import androidx.compose.runtime.*
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.http.*
import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.serialization.json.Json
import meineglasfaser.api.ShopBasket
import meineglasfaser.api.ShopBasketProductWithAddons
import meineglasfaser.api.routes.ShopRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.setJsonBody

val GlobalShopBasket = MutableStateFlow(
    ShopBasket(
        products = emptyList(),
        coupons = emptyList(),
    )
)

object ShopBasketDAO {
    fun addProduct(entry: ShopBasketProductWithAddons) {
        val current = GlobalShopBasket.value
        GlobalShopBasket.value = current.copy(
            products = current.products + entry,
        )
    }

    fun removeProduct(productId: String) {
        val current = GlobalShopBasket.value
        GlobalShopBasket.value = current.copy(
            products = current.products.filter { it.product.id != productId },
        )
    }

    fun removeProductAddon(productId: String, addonId: String) {
        val current = GlobalShopBasket.value
        GlobalShopBasket.value = current.copy(
            products = current.products.map { entry ->
                if (entry.product.id != productId) {
                    entry
                } else {
                    entry.copy(
                        addons = entry.addons.filter { it.id != addonId },
                    )
                }
            },
        )
    }

    fun clear() {
        GlobalShopBasket.value = ShopBasket(
            products = emptyList(),
            coupons = emptyList(),
        )
    }
}

@Composable
fun ProvideShopBasketState() {
    LaunchedEffect(Unit) {
        val saved = window.localStorage.getItem("shopBasket")
        if (saved != null) {
            try {
                val basket = Json.decodeFromString<ShopBasket>(saved)
                GlobalShopBasket.value = basket
            } catch (_: Throwable) {
                // ignored
            }
        }
        GlobalShopBasket.collectLatest { basket ->
            window.localStorage.setItem("shopBasket", Json.encodeToString(basket))
        }
    }
}

@Composable
fun fetchComputedBasket(includeTax: Boolean): Pair<ShopBasket, ShopBasket.Computed?> {
    val basket by GlobalShopBasket.collectAsState()
    var computedBasket by remember { mutableStateOf<ShopBasket.Computed?>(null) }

    LaunchedEffect(basket) {
        BackendApi.post(ShopRoutes.Basket.Compute(includeTax)) {
            setJsonBody(basket)
        }.fold(
            onSuccess = { response ->
                val computed = response.body<ShopBasket.Computed>()
                computedBasket = computed
            },
            onFailure = { error ->
                when (error) {
                    is ClientRequestException if error.response.status == HttpStatusCode.BadRequest -> {
                        val sanitizedBasket = error.response.body<ShopBasket>()
                        GlobalShopBasket.value = sanitizedBasket
                        computedBasket = null
                    }
                    else -> {
                        Toasts.display(
                            Toast.error("Fehler beim Berechnen des Warenkorbs: ${error.message}"),
                        )
                        console.log(error.stackTraceToString())
                    }
                }
            }
        )
    }

    return basket to computedBasket
}
